const FLATS_API_URL = `/api/v1/flats?timestamp=${Date.now()}`;
const MAPPINGS_API_URL = `/api/v1/flats/mappings`;
const DATA_PREFIX = 'data-';
const INTERACTIVE_TAGS = ['A', 'INPUT', 'BUTTON', 'LABEL'];

const STATES = {
    'volny': 162,
    'predrezervovany': 164,
    'rezervovany': 163,
    'predany': 161,
}

const FLOORS = {
    '0': 149,
    '1': 150,
    '2': 143,
    '3': 144,
    '4': 145,
    '5': 146,
    '6': 147,
    '7': 148,
    '8': 151,
    '9': 152,
    '10': 153,
    '11': 154,
    '12': 155,
    '13': 156,
    '14': 157,
    '15': 158,
    '16': 159,
    '17': 160,
    '18': 257,
    '19': 258,
}

const BUILDINGS = {
    'I': 11,
    'J': 5,
    'K': 14,
    'L': 15,
    'M': 17,
    'N': 19,
    'O': 29,
    'P': 31,
    'R': 32,
    'S': 178,
    'T': 254,
    'U': 255,
    'V': 256,
}

const PHASES = {
    'ceresne-lake': 6,
    'ceresne-up': 167,
    'ceresne-residence': 30,
    'ceresne-plaza': 168,
}

const ROOMS = {
    '1': 170,
    '1.5': 177,
    '2': 174,
    '3': 171,
    '4': 169,
    '5': 172,
}

const TYPOLOGIES = {
    'mezonet': 187,
    's-balkonom': 188,
    's-loggiou': 189,
    's-predzahradkou': 190,
    's-terasou': 191,
    's-logiou': 195,
}

export default function () {
    return {
        totalFlats: 0,
        loadedFlats: 0,
        loadPerPage: 20,
        page: 1,
        totalPages: 0,
        loading: false,
        compare: [],
        areaRange: this.$persist([30, 281]).using(sessionStorage),
        priceRange: this.$persist([0, 748420]).using(sessionStorage),
        priceSlider: {},
        areaSlider: {},
        openRow: 0,
        canLoadMore: true,
        showCompare: false,
        compareUrl: '',
        currentPriceDefaults: this.$persist(false).using(sessionStorage),
        currentAreaDefaults: this.$persist(false).using(sessionStorage),
        availableBenefits: [],
        benefitsMapping: {},
        sort: this.$persist({
            direction: '',
            field: '',
            type: '',
        }).using(sessionStorage),
        filter: this.$persist({
            taxonomies: {
                phases: [],
                buildings: [],
                floors: [],
                rooms: [],
                states: [],
                typologies: [],
                benefits: [],
            },
            meta: {
                price: {min: 0, max: 0},
                area: {min: 0, max: 0},
            },
        }).using(sessionStorage),

        async loadTaxonomyMappings() {
            try {
                const response = await axios.get(MAPPINGS_API_URL);
                this.benefitsMapping = response.data.benefits || {};
            } catch (error) {
                this.TAXONOMY_MAPS = {
                    benefits: {}
                };
            }
        },

        /**
         * Updates the URL query string with the current filter properties.
         */
        updateUrlWithFilters() {
            const params = new URLSearchParams();

            if (this.filter.meta.price.min > this.priceRange[0] || this.filter.meta.price.max < this.priceRange[1]) {
                params.set('cena', `${parseInt(this.filter.meta.price.min)}-${parseInt(this.filter.meta.price.max)}`);
            }

            if (this.filter.meta.area.min > this.areaRange[0] || this.filter.meta.area.max < this.areaRange[1]) {
                params.set('plocha', `${parseInt(this.filter.meta.area.min)}-${parseInt(this.filter.meta.area.max)}`);
            }

            const TAXONOMY_MAPS = {
                states: STATES,
                floors: FLOORS,
                phases: PHASES,
                typologies: TYPOLOGIES,
                rooms: ROOMS,
                buildings: BUILDINGS,   
                benefits: this.benefitsMapping
            };
            const TAXONOMY_KEYS = {
                states: 'stav',
                floors: 'podlazie',
                phases: 'etapa',
                typologies: 'typologia',
                rooms: 'dispozicia',
                buildings: 'budova',
                benefits: 'vyhoda'
            };

            Object.keys(TAXONOMY_MAPS).forEach(taxonomy => {
                const selected = this.filter.taxonomies[taxonomy];
                const paramKey = TAXONOMY_KEYS[taxonomy];
                const taxonomyMap = TAXONOMY_MAPS[taxonomy];

                if (selected.length) {
                    const values = selected
                        .map(item => Object.keys(taxonomyMap).find(key => taxonomyMap[key] == item))
                        .filter(Boolean)
                        .join(',');

                    if (values) {
                        params.set(paramKey, values);
                    } else {
                        params.delete(paramKey);
                    }
                } else {
                    params.delete(paramKey);
                }
            });

            const url = new URL(window.location.href);
            const currentParams = new URLSearchParams(url.search);

            for (const [key, value] of currentParams.entries()) {
                if (
                    !params.has(key) &&
                    !['cena', 'plocha', 'stav', 'podlazie', 'etapa', 'typologia', 'dispozicia', 'budova', 'vyhoda'].includes(key)
                ) {
                    params.append(key, value);
                }
            }

            url.search = params.toString();
            const finalUrl = decodeURIComponent(url.toString().replace(/\?$/, ''));
            window.history.pushState(null, '', finalUrl);

            this.initMap();
        },

        /**
         * Gets the value of a query string parameter by name.
         *
         * @param {string} name - The name of the query string parameter.
         * @return {string|null} The value of the query string parameter, or null if not found.
         */
        getQueryStringValue(name) {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get(name);
        },

        /**
         * Determines if any filter condition is currently active.
         *
         * @return {boolean} True if any filter (taxonomies, price range, or area range) is active, otherwise false.
         */
        get isFilterActive() {
            return Object.values(this.filter.taxonomies).some(arr => arr.length > 0) ||
                this.filter.meta.price.min > this.priceRange[0] ||
                this.filter.meta.price.max < this.priceRange[1] ||
                this.filter.meta.area.min > this.areaRange[0] ||
                this.filter.meta.area.max < this.areaRange[1] ||
                (this.filter.benefits && this.filter.benefits.length > 0);
        },

        /**
         * Initializes the application by performing several setup tasks:
         * - Initializes sliders used in the application
         * - Fetches data related to flats asynchronously
         * - Adds event listeners to checkboxes for user interactions
         * - Watches for changes to the filter property and reacts accordingly
         * @return {Promise<void>} A promise that resolves when the initialization process is complete.
         */
        async init() {

            await this.loadTaxonomyMappings();

            const query_phase = this.getQueryStringValue('etapa');
            const query_disposition = this.getQueryStringValue('dispozicia');
            const query_typology = this.getQueryStringValue('typologia');
            const query_state = this.getQueryStringValue('stav');
            const query_floor = this.getQueryStringValue('podlazie');
            const query_building = this.getQueryStringValue('budova');
            const query_price = this.getQueryStringValue('cena');
            const query_area = this.getQueryStringValue('plocha');
            const query_benefits = this.getQueryStringValue('vyhoda'); 

            if (query_phase || query_disposition || query_typology || query_state || query_floor || query_building || query_price || query_area || query_benefits) {
                this.resetFilterAttributes();
                ImageMapPro.subscribe((action) => {
                    if (action.type === 'mapInit') {
                        // this.$nextTick(() => this.scrollToFilter())
                    }
                });
                this.$nextTick(() => this.scrollToFlatTable());
            }

            const TAXONOMY_KEYS = {
                query_phase: {key: 'phases', data: PHASES},
                query_disposition: {key: 'rooms', data: ROOMS},
                query_typology: {key: 'typologies', data: TYPOLOGIES},
                query_state: {key: 'states', data: STATES},
                query_floor: {key: 'floors', data: FLOORS},
                query_building: {key: 'buildings', data: BUILDINGS},
                query_benefits: {key: 'benefits', data: this.benefitsMapping},
            };

            for (const [queryKey, {key, data}] of Object.entries(TAXONOMY_KEYS)) {
                const queryValue = eval(queryKey); // evaluates variables like `query_phase`
                if (queryValue) {
                    this.filter.taxonomies[key] = queryValue.split(',')
                        .map(value => value.trim())
                        .filter(value => data.hasOwnProperty(value))
                        .map(value => data[value]);
                }
            }

            if (query_price) {
                const [min, max] = query_price.split('-').map(parseFloat);
                this.filter.meta.price = {min, max};
            }

            if (query_area) {
                const [min, max] = query_area.split('-').map(parseFloat);
                this.filter.meta.area = {min, max};
                console.log(this.filter.meta.area)
            }

            this.initializeSliders();
            await this.fetchFlats();
            this.addCheckboxListeners();
            this.$watch('filter', () => this.useArguments());
        },

        /**
         * Sets the order for sorting based on the specified field and type.
         *
         * @param {string} orderBy - The field to sort by.
         * @param {string} type - The type of sorting (e.g., 'numerical', 'alphabetical').
         * @return {Promise<void>} A promise that resolves once the order has been set and any necessary actions have been taken.
         */
        async setOrder(orderBy, type) {
            this.sort.field = orderBy;
            this.sort.direction = this.sort.direction === 'asc' ? 'desc' : 'asc';
            this.sort.type = type;
            await this.useArguments();
        },

        /**
         * Sets the specified filter and value from the event and updates the filter attributes.
         *
         * @param {Object} event - The event containing filter details.
         * @param {Object} event.detail - Contains filter and value.
         * @param {string} event.detail.filter - The filter attribute to be set.
         * @param {string} event.detail.value - The value to be added to the filter attribute.
         * @return {void}
         */
        setFilter(event) {

            const {filter, value, artboard} = event.detail;

            if (!filter && !value && !artboard) {
                this.resetFilterAttributes();
                return;
            }

            if (artboard) {
                if (window.innerWidth > 768) {
                    ImageMapPro.changeArtboard('ceresne', artboard);
                } else {
                    this.scrollToFilter();
                }
            } else {
                if (window.innerWidth <= 768) {
                    this.scrollToFilter();
                }
            }

            if (filter === 'buildings') {
                this.resetFilterAttributes();
            }

            if (filter === 'floors') {
                const building = artboard.split('-')[0];
                this.filter.taxonomies.buildings = [BUILDINGS[building]];
            }

            if (this.filter.taxonomies.hasOwnProperty(filter)) {
                if (Array.isArray(value)) {
                    this.filter.taxonomies[filter].push(...value);
                } else {
                    this.filter.taxonomies[filter].push(value);
                }
            }
        },

        /**
         * Resets the filter attributes to their default values.
         *
         * @return {void} No return value.
         */
        resetFilterAttributes() {
            this.filter.taxonomies = {
                phases: [],
                buildings: [],
                floors: [],
                rooms: [],
                states: [],
                typologies: [],
                benefits: [],
            };
            this.filter.meta = {
                price: {min: this.priceRange[0], max: this.priceRange[1]},
                area: {min: this.areaRange[0], max: this.areaRange[1]},
            };

            this.sort = {
                direction: '',
                field: '',
                type: '',
            }
        },

        initMap: function () {

            window.addEventListener('popstate', (event) => {
                this.initMap();
            });
            const urlParams = new URLSearchParams(window.location.search);
            const building = urlParams.get('budova')?.replace(/,/g, '');
            const floor = urlParams.get('podlazie');

            if (building && !floor) {
                ImageMapPro.changeArtboard('ceresne', building);
            } else if (building && floor) {
                ImageMapPro.changeArtboard('ceresne', `${building}-${floor}`);
            } else {
                ImageMapPro.changeArtboard('ceresne', 'Čerešne');
            }
        },

        /**
         * Resets the flats, fetches updated flats data asynchronously,
         * and updates the count of flats.
         *
         * @return {Promise<void>} A promise that resolves when all operations
         *                         (resetting, fetching, and updating count) are complete.
         */
        async useArguments() {
            this.page = 1;
            this.resetFlats();
            await this.fetchFlats();
        },

        /**
         * Resets the flats container, clears the current list of flats, and resets pagination and load tracking.
         *
         * @return {void} This method does not return a value.
         */
        resetFlats() {
            this.$refs.flatsContainer.innerHTML = '';
            this.page = 1;
            this.flats = [];
            this.loadedFlats = 0;
        },

        /**
         * Fetches a list of flats from the API using the current filter, sort, and pagination settings.
         *
         * @return {Promise<void>} A promise that resolves when the flats data has been fetched and handled.
         */
        async fetchFlats() {
            try {
                this.loading = true;
                // if (this.isFilterActive || this.page > 1) {
                //     this.$nextTick(() => this.scrollToFilter());
                // }
                if (this.page > 1) {
                    this.scrollToFilter();
                }
                this.$refs.flatsContainer.innerHTML = ''
                const response = await axios.get(FLATS_API_URL, {
                    params: {
                        filter: this.filter,
                        sort: this.sort,
                        page: this.page
                    }
                });
                this.handleApiResponse(response.data);
            } catch (error) {
                console.error('Error fetching flats:', error);
            } finally {
                this.loading = false;
            }

            this.updateUrlWithFilters()
        },

        /**
         * Handles the API response and updates the UI accordingly.
         *
         * @param {Object} data - The API response data.
         * @param {string} data.html - The HTML content to be inserted.
         * @param {number} data.total - The total number of flats available.
         * @param {number} data.total_pages - The total number of pages available.
         * @param {number} data.per_page - The number of flats loaded per page.
         * @param {number[]} data.price_range - The min and max price range of the flats.
         * @param {number[]} data.area_range - The min and max area range of the flats.
         *
         * @return {void}
         */
        handleApiResponse(data) {
            // this.$refs.flatsContainer.insertAdjacentHTML('beforeend', data.html);
            this.$refs.flatsContainer.innerHTML = data.html;
            this.$refs.pagination.innerHTML = data.pagination;
            this.totalFlats = data.total;
            this.totalPages = data.total_pages;
            this.loadPerPage = data.per_page;
            this.loadedFlats += data.per_page;
            this.availableBenefits = data.available_benefits || [];
            // this.priceRange = data.price_range;
            // this.areaRange = data.area_range;
            this.updateFilters();
            this.updateSliders();
            // this.updateFlatsCount();
            this.updateBenefitsUI();

            if (!this.currentPriceDefaults) {
                this.$refs.priceMin.innerText = new Intl.NumberFormat('sk-SK', {
                    style: 'currency',
                    currency: 'EUR',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                    trailingZeroDisplay: 'stripIfInteger'
                }).format(this.priceRange[0]);

                this.$refs.priceMax.innerText = new Intl.NumberFormat('sk-SK', {
                    style: 'currency',
                    currency: 'EUR',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                    trailingZeroDisplay: 'stripIfInteger'
                }).format(this.priceRange[1]);
            }
            if (!this.currentAreaDefaults) {
                this.$refs.areaMin.innerText = this.areaRange[0] + ' m²';
                this.$refs.areaMax.innerText = this.areaRange[1] + ' m²';
            }

            this.canLoadMore = this.totalFlats > this.loadedFlats;
        },

        /**
         * Updates the UI state of benefit checkboxes based on availability.
         * Disables checkboxes that are not in the availableBenefits list.
         */
        updateBenefitsUI() {
            // Select the inputs inside the wrapper
            const benefitInputs = document.querySelectorAll('.filter-benefit input[type="checkbox"]');

            benefitInputs.forEach(input => {
                const benefitKey = parseInt(input.value);
                
                const isAvailable = this.availableBenefits.includes(benefitKey);
                
                const shouldDisable = !isAvailable && !input.checked;
                
                input.disabled = shouldDisable;

                const parent = input.parentElement;
                if (parent) {
                    parent.classList.toggle('tw-opacity-50', shouldDisable);
                    parent.classList.toggle('tw-pointer-events-none', shouldDisable);
                }
            });
        },

        /**
         * Loads more items by incrementing the page number and fetching the next set of data.
         * Updates the flats count after fetching.
         *
         * @return {Promise<void>} A promise that resolves once the data is fetched and the count is updated.
         */
        async loadMore() {
            this.page++;
            await this.fetchFlats();
            // this.updateFlatsCount();
        },
        async setPage(page) {
            this.page = page;
            await this.fetchFlats();
            // this.updateFlatsCount();
        },

        /**
         * Updates the filter values for 'price' and 'area' with the current ranges.
         *
         * @return {void}
         */
        updateFilters() {
            this.updateFilterMetaValue('price', this.priceRange);
            this.updateFilterMetaValue('area', this.areaRange);
        },

        /**
         * Updates the metadata values of the filter for the specified type with the provided range.
         *
         * @param {string} type - The type of filter to update.
         * @param {Array<number>} range - An array containing the minimum and maximum values for the filter.
         * @return {void}
         */
        updateFilterMetaValue(type, range) {
            this.filter.meta[type].min = this.filter.meta[type].min || range[0];
            this.filter.meta[type].max = this.filter.meta[type].max || range[1];
        },

        /**
         * Updates multiple slider components with new options based on specified criteria.
         *
         * This method updates the configuration of the price and area sliders
         * according to the metadata provided in the filter object. The sliders'
         * new configurations are defined by the specified ranges.
         *
         * @return {void}
         */
        updateSliders() {
            this.updateSliderOptions(this.priceSlider, this.filter.meta.price, this.priceRange);
            this.updateSliderOptions(this.areaSlider, this.filter.meta.area, this.areaRange);
        },

        /**
         * Updates the options of a slider with provided metadata and range values.
         *
         * @param {Object} slider - The slider instance to update.
         * @param {Object} meta - An object containing metadata with min and max properties.
         * @param {number[]} range - An array containing the minimum and maximum range values.
         * @return {void} This method does not return a value.
         */
        updateSliderOptions(slider, meta, range) {
            slider.updateOptions({
                start: [meta.min, meta.max],
                range: {
                    min: range[0],
                    max: range[1],
                },
            }, false);
        },

        /**
         * Initializes the sliders for price and area, sets them up with their respective event handlers,
         * and updates them with default values if available.
         *
         * @return {void} This function does not return anything.
         */
        initializeSliders() {
            this.priceSlider = this.createSlider('price-slider', 5000, this.handlePriceChange.bind(this), this.handlePriceSlide.bind(this));
            this.areaSlider = this.createSlider('area-slider', 3, this.handleAreaChange.bind(this), this.handleAreaSlide.bind(this));
            if (this.currentPriceDefaults) {
                this.handlePriceSlide(this.currentPriceDefaults);
            }
            if (this.currentAreaDefaults) {
                this.handleAreaSlide(this.currentAreaDefaults);
            }
        },

        /**
         * Creates a new slider using the noUiSlider library.
         *
         * @param {string} id - The ID of the HTML element where the slider will be created.
         * @param {number} step - The step value for the slider.
         * @param {function} onChange - The callback function to be called when the slider value changes.
         * @param {function} onSlide - The callback function to be called when the slider is being slid.
         * @return {Object} - The created noUiSlider instance.
         */
        createSlider(id, step, onChange, onSlide) {
            const slider = noUiSlider.create(document.getElementById(id), {
                start: [0, 0],
                step,
                connect: true,
                range: {min: 0, max: 0},
            });
            slider.on('change', onChange);
            slider.on('slide', onSlide);
            return slider;
        },

        /**
         * Handles the change in price by updating the filter metadata with new minimum and maximum values.
         *
         * @param {Array<number>} values - An array where the first element is the new minimum price and the second element is the new maximum price.
         * @return {void}
         */
        handlePriceChange(values) {
            this.filter.meta.price.min = values[0];
            this.filter.meta.price.max = values[1];
        },

        /**
         * Handles changes to the area range by updating the minimum and maximum values.
         *
         * @param {number[]} values - An array containing two elements: the minimum area value at index 0 and the maximum area value at index 1.
         * @return {void}
         */
        handleAreaChange(values) {
            this.filter.meta.area.min = values[0];
            this.filter.meta.area.max = values[1];
        },

        /**
         * Handles the price slider, formatting and displaying the minimum and maximum values.
         *
         * @param {number[]} values - The current minimum and maximum prices selected from the slider.
         * @return {void}
         */
        handlePriceSlide(values) {
            this.currentPriceDefaults = values;
            this.$refs.priceMin.innerText = new Intl.NumberFormat('sk-SK', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
                trailingZeroDisplay: 'stripIfInteger'
            }).format(values[0]);
            this.$refs.priceMax.innerText = new Intl.NumberFormat('sk-SK', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
                trailingZeroDisplay: 'stripIfInteger'
            }).format(values[1]);
        },

        /**
         * Handles the event when the area slider values change.
         *
         * @param {Array<number>} values - An array of two numbers representing the selected minimum and maximum areas.
         * @return {void}
         */
        handleAreaSlide(values) {
            this.currentAreaDefaults = values;
            this.$refs.areaMin.innerText = parseInt(values[0]) + ' m²';
            this.$refs.areaMax.innerText = parseInt(values[1]) + ' m²';
        },


        /**
         * Adds event listeners to checkboxes with the class `.compare-checkbox`.
         * Listens for `change` events on the document and calls `handleCheckboxChange`
         * if the event's target matches a checkbox with the specified class.
         *
         * @return {void}
         */
        addCheckboxListeners() {
            document.addEventListener('change', (event) => {
                if (event.target.matches('.compare-checkbox')) {
                    this.handleCheckboxChange(event);
                }
            });
        },

        /**
         * Handles the change event for a checkbox element.
         * This method updates the comparison list based on the checkbox state
         * (checked or unchecked) and manages the enabling/disabling of checkboxes.
         *
         * @param {Event} event - The DOM event object representing the change event
         *                        triggered by the checkbox.
         * @return {void} This method does not return a value.
         */
        handleCheckboxChange(event) {
            const checkbox = event.target;
            const attributes = this.extractDataAttributes(checkbox);
            if (checkbox.checked) {
                this.compare.push(attributes);
            } else {
                this.compare = this.compare.filter(item => item.id !== attributes.id);
            }

            if (this.compare.length === 2) {
                this.compareUrl = `/porovnanie-bytov?ids[]=${this.compare.map(item => item.id).join('&ids[]=')}`;
            }

            this.updateCheckboxState();
            this.showCompare = this.compare.length === 2;
        },

        /**
         * Extracts data attributes from a given checkbox element.
         *
         * @param {HTMLElement} checkbox The checkbox element from which to extract data attributes.
         * @return {Object} An object containing key-value pairs of the data attributes.
         */
        extractDataAttributes(checkbox) {
            const attributes = {};
            Array.from(checkbox.attributes).forEach(attr => {
                if (attr.name.startsWith(DATA_PREFIX)) {
                    const key = attr.name.substring(DATA_PREFIX.length);
                    attributes[key] = attr.value;
                }
            });
            return attributes;
        },

        /**
         * Updates the state of checkboxes with the class 'compare-checkbox' based on the length of the 'compare' array.
         * If the length of the 'compare' array is 2, all unchecked checkboxes will be disabled.
         *
         * @return {void} Does not return a value.
         */
        updateCheckboxState() {
            const shouldDisable = this.compare.length === 2;
            document.querySelectorAll('.compare-checkbox').forEach(cb => {
                if (!cb.checked) {
                    cb.disabled = shouldDisable;
                }
            });
        },


        /**
         * Clears the comparison list by resetting `this.compare` to an empty array and setting `this.showCompare` to false.
         * Also unchecks and enables all comparison checkboxes in the DOM.
         *
         * @return {void}
         */
        clearCompare() {
            this.compare = [];
            this.showCompare = false;
            document.querySelectorAll('.compare-checkbox').forEach(cb => {
                cb.checked = false;
                cb.disabled = false;
            });
        },

        /**
         * Navigates to the given URL unless the event target is a specific interactive element.
         *
         * @param {string} link - The URL to navigate to.
         * @param {Event} event - The event object used to determine the target element.
         * @return {string|undefined} The new URL if navigation occurs, otherwise undefined.
         */
        goToFlat(link, event) {
            if (INTERACTIVE_TAGS.includes(event.target.tagName)) {
                return;
            }
            return window.location.href = link;
        },
        /**
         * Smoothly scrolls the page to the filter section.
         *
         * @return {void} This method does not return a value.
         */
        scrollToFilter() {
            const filterElement = document.querySelector('#filter');
            if (filterElement) {
                filterElement.scrollIntoView({behavior: 'smooth'});
            }
        },
        /**
         * Smoothly scrolls the page to the filter section.
         *
         * @return {void} This method does not return a value.
         */
        scrollToFlatTable() {
            const filterElement = document.querySelector('#flat_table');
            if (filterElement) {
                filterElement.scrollIntoView({behavior: 'smooth'});
            }
        }
    }
}
